import React from 'react';
import { Container, Section, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { CorporateAccountsController } from 'src/components/enterprise/Parents/Admin/CorporateAccountsController/CorporateAccountsController';
import { useCanAccessParentAdminFlows } from 'src/components/enterprise/Parents/Admin/hooks/useCanAccessParentAdminFlows/useCanAccessParentAdminFlows';

export const CorporateAccounts: React.FC = () => {
  const isUserAllowedAccess = useCanAccessParentAdminFlows();

  if (!isUserAllowedAccess) {
    return null;
  }

  return (
    <Container variant="default">
      <Section inset="sm">
        <PageHeader>
          <Stack y="lg">
            <CorporateAccountsController />
          </Stack>
        </PageHeader>
      </Section>
    </Container>
  );
};
